module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_karlskoga-df4364cbcc8c36097061b1d8707eaffb.png";